<template>
  <div
    :id="gpAutotestName"
    :class="[type === 'tab' ? $.tabs : $.button , small ? $.small : '']"
    :style="{ ...styles}"
  >
    <div
      v-for="(tab, index) in tabs"
      :key="index"
      :class="[
        type === 'tab' ? $.tabs_item : $.button_item,
        tab[activeBy] === activeItem[activeBy] ? $.active : '',
        gpAutotestName ? gpAutotestName + `_${tab.type}` : '',
        tab.marker ? $.marker : ''
      ]"
      :style="{borderColor: tab[activeBy] === activeItem[activeBy] ? color : 'transparent', width: getWidth(tab), maxWidth: getMaxWidth(tab)}"
      @click="selectTab(tab)"
    >
      <sprite
        v-if="tab.icon"
        :class="$.tabs_item__icon"
        :name="tab.icon.name"
        :size="tab.icon.size || 24"
        :type="tab.icon.type || 'regular'"
        :color="tab[activeBy] === activeItem[activeBy] ? color : '#b2b2b2'"
      />
      <span
        :class="[type === 'tab' ? $.tabs_item__title : $.button_item__title]"
        :style="{
          marginLeft: tab.icon ? '6px' : '',
          color: getTextColor(tab),
          fontSize: getFontSize(tab),
        }"
      >{{ tab.title }} {{ amounts[tab.type] >= 100 ? '99+' : amounts[tab.type] }}</span>
      <div
        v-if="tabs.length > 2 && type === 'button' "
        :class="[ $.button_item__separator]"
      />
    </div>
  </div>
</template>

<script>
import sprite from '../VueIcon/svgSprite.vue';

export default {
  components: { sprite },
  props: {
    gpAutotestName: {
      type: String,
      required: true,
      default: '',
    },
    tabs: {
      type: Array,
      required: true,
    },
    small: {
      type: Boolean,
      required: false,
      default: true,
    },
    activeBy: {
      type: String,
      required: false,
      default: 'id',
    },
    type: {
      type: String,
      required: true,
      default: 'tab',
    },
    active: {
      type: Object,
      required: true,
    },
    amounts: {
      type: Object,
      required: false,
      default: {},
    },
    color: {
      type: String,
      required: false,
      default: '#1565C0',
    },
    styles: { type: Object, required: false },
    blockedInnerSelection: { type: Boolean, required: false, default: false },
  },

  data() {
    return {
      activeItem: this.active,
    };
  },

  watch: {
    active(val) {
      if (val) {
        this.activeItem = val;
      }
    },
  },

  methods: {
    getWidth(tab) {
      if (tab.width) {
        return 'fit-content';
      }

      if (this.type === 'button') {
        // const width = `${100 / this.tabs.length}%`;

        // return width;
        return '100%';
      }

      return '';
    },

    getMaxWidth(tab) {
      if (tab.width) {
        return `${tab.width}px`;
      }

      return '';
    },

    getTextColor(tab) {
      if (this.type === 'tab' && tab[this.activeBy] === this.activeItem[this.activeBy]) {
        return this.color;
      }

      if (this.type === 'button' && tab[this.activeBy] === this.activeItem[this.activeBy]) {
        return '#191919';
      }

      return '#b2b2b2';
    },

    getFontSize(tab) {
      if (tab.fontSize) {
        return `${tab.fontSize}px`;
      }

      return '14px';
    },

    selectTab(tab) {
      this.$emit('onToggle', tab);

      if (!this.blockedInnerSelection) {
        this.activeItem = tab;
      }
    },
  },
};
</script>

<style module='$' src='./less/tabs.less'></style>
